import { TournamentEntity, MatchEntity, UserEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';

export const useUserWinningAnimation = (
  gamingActivity: TournamentEntity | MatchEntity,
  activeUser: Partial<UserEntity>
) => {
  const isWinningAnimationAvailable = useMemo(() => {
    if (!activeUser?.id) {
      return false;
    }

    return gamingActivity?.winAnimationViewedBy?.includes(activeUser.id);
  }, [activeUser.id, gamingActivity?.winAnimationViewedBy]);

  return {
    isWinningAnimationAvailable,
  };
};
